export interface SpaceProps {
  m?: string;
  mt?: string;
  mr?: string;
  mb?: string;
  ml?: string;
  mx?: string;
  my?: string;
}

export const space = <Props extends SpaceProps>({ m = '', mx, my, mt, mr, mb, ml }: Props) => `
    margin: ${m};
    margin-top: ${mt ?? my ?? ''};
    margin-bottom: ${mb ?? my ?? ''};
    margin-right: ${mr ?? mx ?? ''};
    margin-left: ${ml ?? mx ?? ''};
`;

export function isolateSpaceProps<Props extends SpaceProps>(props: Props) {
  const { m, mt, mr, mb, ml, mx, my, ...restProps } = props;

  return { spaceProps: { m, mt, mr, mb, ml, mx, my }, restProps };
}
